import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Te tomas en serio la artesanía en cuero, pero pasas horas adivinando medidas y terminas desperdiciando material muy costoso.', 'Llevas tiempo buscando plantillas limpias y profesionales, pero las que encuentras son confusas o no incluyen instrucciones claras de ensamblaje.', 'Compras patrones carísimos uno por uno y sientes que tu presupuesto se esfuma antes de empezar a fabricar.', 'Quieres iniciar tu propio negocio de marroquinería o regalos hechos a mano, pero te falta la confianza de tener diseños probados que se vean premium.', 'Tienes las herramientas, pero sientes que existe una "brecha" en tu técnica porque desconoces los secretos de costura y acabados de los artesanos experimentados.'];
export function PainPoints() {
  return <section className="bg-offwhite py-20 px-4 sm:px-6 lg:px-8" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-115">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-leather-dark mb-4" data-id="element-116">
            Este Recurso Es Para Ti Si…
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-117"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-118">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-5 rounded-xl bg-red-50/50 border border-red-100 shadow-sm" data-id="element-119">
              <XCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" data-id="element-120" />
              <p className="text-gray-800 text-lg leading-relaxed" data-id="element-121">{point}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}